module.exports = __webpack_public_path__ + "img/mergdata_digi_variation_3.0bc953a0.png";